export default __webpack_public_path__ + "static/media/barcode.01a2cb53.png";